import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  School,
  Groups,
  Science,
  Computer,
  Storage,
  Psychology,
  ExpandMore,
} from '@mui/icons-material';

const Students = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const bePrograms = [
    {
      title: "Computer Science Engineering",
      icon: <Computer sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: "Comprehensive program focusing on computer science fundamentals, software development, and system design.",
      years: [
        {
          year: "2nd Year",
          students: [
            { name: "Section A", count: 67, studentList: [
              "ABHIMANYU",
              "ABHISHEK AGRAWAL",
              "ADITYA",
              "AKASH GURJAR",
              "AMIT SHYORAN",
              "ANIL KUMAR MEENA",
              "ANISHK GUPTA",
              "ARYAN JANGIR",
              "ASHA MEENA",
              "ASTHA AGRAWAL",
              "AVADHI SHARMA",
              "AWADHESH KHATRI",
              "BHAVESH MANAT",
              "CHANDRIKA SAINI",
              "DEEPAK JEENGAR",
              "DEVENDRA SINGH",
              "DIKSHRAJ RAWAT",
              "DIMPLE NAGARWAL",
              "DURGESH PANWAR",
              "GAURAVRAJ SINGH RATHORE",
              "GHANSHYAM",
              "HIMANSHU LOHAR",
              "JAY KUMAR",
              "KAJAL",
              "KARAN SANPAL",
              "KHUSHI CHOUHAN",
              "KOMAL DHEER",
              "KUMKUM SISODIYA",
              "MANOJ KUMAR",
              "MAYANK GODARA",
              "MILLI RANKA",
              "MOHAMMED ARBAZ",
              "MOHIT POHWANI",
              "MS. SUMITRA CHOUDHARY",
              "NAMAN JASROTIA",
              "NAVEEN JAGRAT",
              "NISHANT BHARDWAJ",
              "NITIN BAIRWA",
              "OM PRAKASH",
              "OME TIWARI",
              "OMPRAKASH MEENA",
              "PARTH LADDA",
              "PARTH SHEKHAWAT",
              "PRINCE JANGID",
              "PRIYANK MUNDEL",
              "PULKIT BAGARIA",
              "PUSHKAR SAINI",
              "RADHIKA PRAJAPAT",
              "RAGHAV KHANDELWAL",
              "RAHUL KUMHAR",
              "RATNESH JAIN",
              "RAUNAK SIKARWAR",
              "RIYA CHAWLA",
              "ROHIT BIHANI",
              "SAKSHAM JHALANI",
              "SAKSHI PARMAR",
              "SAMRIDDHI SIROHI",
              "SAYAM SHARMA",
              "SHAKTI SINGH NARUKA",
              "SUMIT SHARMA",
              "TANVI SHEKHAWAT",
              "TARACHAND TANAN",
              "UMESH",
              "VIDHI CHOUDHARY",
              "VISHAL SAINI",
              "YASHVI BHANSALI",
              "YOGITA MOURYA"
            ]}
          ]
        },
        {
          year: "3rd Year",
          students: [
            { name: "Section A", count: 75, studentList: [
              "MAHENDRA GURJAR",
              "SHASHANK RAJPUROHIT",
              "AAYUSH SONI",
              "ADITI GAUR",
              "ALISHA KHAN",
              "AMAN KUMAR",
              "ARYAN GARASIYA",
              "AVNEE DADHICH",
              "AYUSH VYAS",
              "BHAVESH GARG",
              "BHUPENDRA KALAL",
              "DISHA SINGHVI",
              "DISHA SONAWAT",
              "DUSHYANT MAKWANA",
              "GARVIT CHOURASIA",
              "HANSIKA CHAUDHRY",
              "HARDIK JAIN",
              "HIMESH NAMA",
              "JAISHIKHA SHEKHAWAT",
              "KAILASH",
              "KANAK PRAJAPAT",
              "KANCHAN",
              "KANHAIYA LAL",
              "KHUSHI ANIL CHOUDHARY",
              "KOVID DADHICH",
              "KRISHNA BAIRWA",
              "KRISHNA GURJAR",
              "KULDEEP SINGH",
              "MAYANK AGGARWAL",
              "NAVYA KHANDELWAL",
              "NIKITA MEENA",
              "PALLAVI KAROL",
              "PANKAJ KUMAR GOYAL",
              "PAWAN KUMAR",
              "PAYAL SONI",
              "POOJA KUMARI",
              "POORTI GUPTA",
              "PRADYUMN CHAUDHARY",
              "PRAKHAR AGRAWAL",
              "PRANAV GUPTA",
              "PRIMAL SUTHAR",
              "RAHUL MEHTA",
              "RAJVEER MEENA",
              "RAMJI LAL SOLANKI",
              "RINKU BALAI",
              "RONAK KHAKHIL",
              "RUMY HOTA",
              "SACHIN KUMAR GOLIA",
              "SEYA MALI",
              "SHAHINA PARVIN",
              "SHIVA MEENA",
              "SHIVAM GURJAR",
              "SIMRAN",
              "SNEHA KISHAN PANWAR",
              "SUNIL",
              "TANISHA BANSAL",
              "TANISHQ DAIYA",
              "TEJENDRA SINGH",
              "UDIT NAVARIYA",
              "VAIBHAV PUROHIT",
              "VIKASH KUMAR MANGAL",
              "VINOD KUMAR MEENA",
              "VISHESH DAGA",
              "ABHAY SHARMA",
              "VEER PAL SINGH",
              "PRAVEEN CHOUDHARY",
              "NIKHIL PAREEK",
              "NISHANT MANDOT",
              "PRANAV CHAWLA",
              "HEMANT GEHLOT",
              "JAYA MAHESHWARI",
              "KANISHKA TOONWAL",
              "RAMESH PRAJAPAT",
              "SANJAY BHATI",
              "VIKAS KUMAR MEENA"
            ]}
          ]
        },
        {
          year: "4th Year",
          students: [
            { name: "Section A", count: 72, studentList: [
              "ISHA PANDEY",
              "AASHITA BHANDARI",
              "MUKUL PARWANI",
              "AARYAN CHOUDHARY",
              "ADITYA VYAS",
              "AJEET JAIN",
              "AKASH PARMAR",
              "ARYAN SWARNKAR",
              "ASAN ALI",
              "AYUSH CHOUHAN",
              "BHARAT SINGH RAJPUT",
              "DAKSHAY SINGH BHATI",
              "GARIMA CHOUDHARY",
              "GUNGUN GURJAR",
              "HARSHITA ATAL",
              "HEM SINGH",
              "HIMESH PARASHAR",
              "IKRAJ KHAN",
              "ISHA MEENA",
              "KALLU KUMARI",
              "KANISHKA SINGHAL",
              "KAVITA JAKHAR",
              "KETAN",
              "KHALIL AHMED",
              "KULDEEP KANWAR",
              "LALIT",
              "LAXITA DETWAL",
              "MAHESH KUMAR",
              "MANAV JHA",
              "MANISH RAHI",
              "MAYANK VERMA",
              "NEERAJ GUPTA",
              "NEETU",
              "NIKHIL SWAMI",
              "PINKI",
              "PRABHBIR SINGH JUNEJA",
              "PRATEEK AGRAWAL",
              "PREETI YADAV",
              "PRINCE DAYMA",
              "PUSHKAR SINGH",
              "RAGHAV BOHRA",
              "RAJAT GAUR",
              "RAKSHIT PANDYA",
              "RISHABH CHAUHAN",
              "RISHABH JAJU",
              "RISHABH SINGH",
              "ROHIT KUMAR NAGAR",
              "ROHIT PANWAR",
              "SAKSHI SINGHAL",
              "SANKALP SHARMA",
              "SUMAN RAJBOHRA",
              "TEJAS BHATI",
              "UDARAM",
              "VAIBHAV BOSE",
              "VIPASH MEENA",
              "VISHWAS GAUR",
              "YASHIKA GARG",
              "HARSH RAJANI",
              "RUDRAKSH VYAS",
              "POONAM SAIN",
              "PRIYANSHU KALAL",
              "ABHINAV BHARAT",
              "AKANKSHA SONI",
              "DEVANSH SILAN",
              "MANOJ BHATT",
              "RITIKA",
              "SHIVENDER SINGH THAKUR",
              "SHUBHAM GEHLOT",
              "TAMANNA CHOUHAN",
              "VISHAL SOLANKI",
              "VISHWAS CHHABRA",
              "VIVEK SAINI"
            ]}
          ]
        }
      ],
      features: [
        "Core programming and algorithms",
        "Software engineering principles",
        "Database management systems",
        "Computer networks and security",
        "Web and mobile development"
      ]
    },
    {
      title: "Information Technology",
      icon: <Storage sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: "Program emphasizing information systems, data management, and enterprise solutions.",
      years: [
        {
          year: "2nd Year",
          students: [
            { name: "Section A", count: 63, studentList: [
              "ABHIMANYU SINGH RAJPUROHIT",
              "ANKIT GUPTA",
              "ANUPAM MAHALA",
              "ARMANDEEP KOUR",
              "ASMI KHANDELWAL",
              "AYUSH KASARA",
              "DALPAT KUMAR",
              "DEEPTI DHAKAR",
              "DHARMENDRA CHOUDHARY",
              "DIKSHANT LABANA",
              "DIVYANSH",
              "DIVYANSH AGARWAL",
              "DIVYANSHI DAUTANIA",
              "DIVYANSHI SHARMA",
              "GAUTAM VAISHNAV",
              "GOVARDHAN SAMARIYA",
              "HARENDRA SINGH",
              "HARSH RATHI",
              "HARSHIT SETH",
              "HARSHITA JHURANI",
              "HARSHITA PARSENDIYA",
              "HIMANSHU",
              "HIRDAY RAJ SINGH",
              "ILIYASH KHAN",
              "ISHITA TATIYA",
              "KAJAL KUMARI",
              "KALPESH BHARDWAJ",
              "KHUSHI MEENA",
              "KRISHAN CHOUDHARY",
              "KRISHNA AGIWAL",
              "KRISHNA PAREEK",
              "MANISHA",
              "MANISHA GOSWAMI",
              "MANMOHAN JANGID",
              "MAYOORI SALARIA",
              "MUSKAN SONI",
              "NITYAM KALAL",
              "PAKHI BAINDARA",
              "PARAG JAIN",
              "PARI KHANDELWAL",
              "POORVI JAIN",
              "PRACHI MEENA",
              "PRATYUSH SHARMA",
              "PRAVEEN KUMAWAT",
              "RAGHAV MANIHAR",
              "RAHUL SHARMA",
              "RAMDEV SONI",
              "RAVINDRA SAINI",
              "RITIK KARWASRA",
              "ROBIN MANAT",
              "ROHIT KUMAR BANSAL",
              "ROHIT SHARMA",
              "RUDRA PRATAP SINGH KITAWAT",
              "SONU KUMAR RAWAT",
              "SUHANI JANGID",
              "SUMIT SHARMA",
              "SUNEEL SHARMA",
              "SURAJ PRAJAPAT",
              "TANURAJ BHATI",
              "VINTI JINGAR",
              "YASH JONWAL",
              "YOGESH KUMAR",
              "YOGYA AGARWAL"
            ]}
          ]
        },
        {
          year: "3rd Year",
          students: [
            { name: "Section A", count: 76, studentList: [
              "AARUSHI GUPTA",
              "ABHAY KHOLWAD",
              "ABHINAV TANAN",
              "ADITYA",
              "ADITYA KAYAL",
              "AJAY KUMAR MEENA",
              "AKASH",
              "AMAN JAIN",
              "ANUSHKA SHARMA",
              "ARYAN JAIN",
              "BHAVESH KUMAR",
              "BHUMIKA KUMARI JAIN",
              "DARSHIT",
              "DHIRENDRA PAL SINGH",
              "DIVYANSH GUPTA",
              "GARV BAHAL",
              "GARVIT SONI",
              "GIRISH GARG",
              "GOVIND SINGH RATHORE",
              "HARSH BHARDWAJ",
              "HARSH BHATI",
              "HARSHIT KUMAR MANGAL",
              "HEMANG CHOUDHARY",
              "JATIN GAUR",
              "JITENDRA SINGH TANWAR",
              "KHUSHI BAIRWA",
              "KHUSHI RANI",
              "KRISHN DUTT",
              "KUSUM CHOUDHARY",
              "LAKSHYA POPTANI",
              "LAVESH AGARWAL",
              "MEGHA ACHARYA",
              "MOHIT GAUR",
              "MOHIT SAINI",
              "NIKHIL",
              "NIKHIL VYAS",
              "NISHTHA JAIN",
              "PANKAJ PAREEK",
              "PARTH SHARMA",
              "PRADEEP DUDI",
              "PRAGYA GUPTA",
              "PRASHANT SINGH",
              "PRAVEEN BEGAR",
              "PRIYA SAINI",
              "PRIYADARSHEENI CHOUDHARY",
              "PRIYANSHU AKHAND",
              "PUNIT JAIN",
              "RAJAT",
              "RAJNEESH GURJAR",
              "RAVI GURJAR",
              "SAHIL MEENA",
              "SAHIL SHARMA",
              "SAURABH KUMAR",
              "SHREYANSHU BHARTIYA",
              "SHUBHAM DUDI",
              "SOURABH BUDANIA",
              "SUMAN KAMAD",
              "TUSHAR VAID",
              "TWINKAL RATHORE",
              "VAIBHAV GAUTAM",
              "VIJAY GURJAR",
              "VIVEK KUMAR",
              "YASH SOMANI",
              "DHARMESH BHADRECHA",
              "GYANESHWARI TAILOR",
              "HITESH SUTHAR",
              "ROHAN MANGAL",
              "SHESHKARAN",
              "ARPIT MALI",
              "LAXMIKANT MALAV",
              "NIKITA TAK",
              "RAHUL TAK",
              "SHIV",
              "SUNIL BHADU",
              "VAIBHAV RATHORE",
              "VIPIN NAGAR"
            ]}
          ]
        },
        {
          year: "4th Year",
          students: [
            { name: "Section A", count: 42, studentList: [
              "ABHISHEK JANGIR",
              "AKSHAY KUMAR GUPTA",
              "ANIKET THAPA",
              "ANSHUL JANGID",
              "ARITREE RAY",
              "ARUN NAIN",
              "ARYAN PARASHAR",
              "ASHISH KUMAR YADAV",
              "BHAVESH VERMA",
              "DEDIPYAMAN PAREEK",
              "DHRUV SAINI",
              "HANSIKA SIGGAR",
              "HARSHIT PRAJAPAT",
              "JATIN AGARWAL",
              "KANAK CHOUHAN",
              "MAHENDRA SINGH GURJAR",
              "MEGHA ROPIA",
              "MRIDUL BANSAL",
              "PARTH SHARMA",
              "PRATEEK DAVE",
              "PRIYAM KUMAR",
              "RAVIKANT JOIYA",
              "ROHIT YADAV",
              "SANJEEV LADWAL",
              "SUDHANSHU BHARGAVA",
              "SUMIT BORAWAT",
              "SWAPNIL",
              "TANMAY JAIN",
              "TAPISH SODANI",
              "UDAY VEER TAK",
              "YOGENDER GODARA",
              "YUKTA MEENA",
              "SATVIK AGRAWAL",
              "AKSHIT GANG",
              "ARYAN SHARMA",
              "ADITYA JATIYA",
              "BHAVYA SHARMA",
              "MANVEER SINGH",
              "RONAK GANDHI",
              "SAGAR JAT",
              "SUMIT",
              "YATHARTH KANOJIYA"
            ]}
          ]
        }
      ],
      features: [
        "Information systems design",
        "Data analytics and visualization",
        "Cloud computing",
        "Enterprise architecture",
        "IT infrastructure management"
      ]
    },
    {
      title: "Artificial Intelligence & Data Science",
      icon: <Psychology sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: "Cutting-edge program focusing on AI, machine learning, and data science applications.",
      years: [
        {
          year: "2nd Year",
          students: [
            { name: "Section A", count: 64, studentList: [
              "AAYUSH MAHAWAR",
              "ABHISHEK SINGH GURJAR",
              "AISHWARIA JOSHI",
              "AJAY RAJ",
              "ANAND BARWAR",
              "ANKUSH MEENA",
              "ARCHI BINDAL",
              "ARIHANT GOLCHHA",
              "ARUN KARWASRA",
              "BHANU PRATAP",
              "BHANVARA RAM",
              "BHAVNESH THAKUR",
              "BHUPESH SHARMA",
              "DHANNA RAM",
              "DILKHUSH MALI",
              "DISHA BHANDARI",
              "DIVISHA GURJAR",
              "DIVYANSH KHANDAL",
              "GODARAM MEENA",
              "HARSHAL SHARMA",
              "JATIN KUMAR",
              "JELLY JAIN",
              "KHUSHBOO MEENA",
              "KRITIKA AGRAWAL",
              "KUNAL SONI",
              "LAMBA PIYUSH RAJESHKUMAR",
              "LUCKY JAWA",
              "M RAJAT KUMAR",
              "MAYANK PATEL",
              "MOHIT JANGIR",
              "NANDINI SHARMA",
              "NAVEEN MALVIYA",
              "NISHA CHOUDHARY",
              "NISHANT",
              "OM PRAKASH SANKHLA",
              "OMPRAKASH KUMAWAT",
              "PALAK",
              "PARIKSHIT BISHNOI",
              "PARIKSHIT SHARMA",
              "PINKU",
              "RAHUL",
              "RAHUL BATRA",
              "RAJAT GARG",
              "RAJEEV JANGID",
              "RAMDAYAL",
              "SANJAY KUMAR KUMAWAT",
              "SANYAM BOHRA",
              "SHAILEE BENIWAL",
              "SONAM KUMARI",
              "SURAJ CHOUHAN",
              "SWAROOP SINGH",
              "TANMAY LUNKER",
              "TANUJ YADAV",
              "TUSHAR MAHAWAR",
              "VIGYAT MAHAJAN",
              "VISHAL PRAJAPAT",
              "VISHAL SHARMA",
              "VRINDHA PARASHAR",
              "YASH JINGER",
              "YASH PAREEK",
              "YASH PRATAP SINGH RATHORE",
              "YASHNAV NIRWAN",
              "YOGESH KUMAWAT",
              "SUKSHAM SHARMA"
            ]}
          ]
        },
        {
          year: "3rd Year",
          students: [
            { name: "Section A", count: 73, studentList: [
              "AYAN KHAN JOIYA",
              "PAWAN KUMAR MEENA",
              "AARUSH KHANDELWAL",
              "AMIT KUMAR",
              "AMIT KUMAR MAHLA",
              "ANKIT CHOUDHARY",
              "ARJUN YADAV",
              "ASHISH",
              "DANIYAL AFTAB",
              "DHEERAJ CHOUDHARY",
              "DIPANSHU SAINI",
              "HARSHVARDHAN SINGH MOYAL",
              "KHUSHWANT MEHRA",
              "LOKESH BOHRA",
              "MANISH BHEENCHAR",
              "PIYUSH YADAV",
              "RIYA SHEKHAWAT",
              "ROMYA JAIN",
              "SHABBIR KHAN",
              "SHIVARTH",
              "SONU",
              "TANVI SAINI",
              "VINAY SINGHAL",
              "VISHAL GHASOLIYA",
              "VISHAL SAINI",
              "YUVRAJ",
              "AKASH BADGOTI",
              "ARIHANT JAIN",
              "ARYAN MATHUR",
              "ASHWANI SEWDA",
              "AYUSH SINGH RAO",
              "BHAVESH SINGH",
              "CHAAHIT SHARMA",
              "CHANDRAKANT BARIK",
              "DEVESH KUMAR",
              "DIVYANK PARIHAR",
              "HEMA RAJPUT",
              "HITESH RATHORE",
              "ISHIKA KARNIK",
              "JATIN KUMAR",
              "JUHI PUROHIT",
              "KHUSHI AKAR",
              "KISHAN KUMAR VERMA",
              "KULDEEP GURJAR",
              "KULWANT SINGH",
              "MAHESH JAIPAL",
              "MAYANK PANWAR",
              "NIKITA NAGAL",
              "NIKITA SEVDA",
              "NITIN SAINI",
              "PIYUSH JAJOO",
              "RAHUL JANGID",
              "RAHUL RAJ",
              "RAVI KUMAR",
              "SACHIN SINGH",
              "SANJAY DHAKAR",
              "SHIV KUMAR MEENA",
              "SIDDHI SAMBHAV",
              "TANISHQ PANCHARIYA",
              "TANVI MANGAL",
              "TISHA GURJAR",
              "VIKRAM SOLANKI",
              "VIVAAN TAK",
              "PRINCE DADHICH",
              "HEMANT KUMAR",
              "SUMEET JANGID",
              "ANURADHA DEMIWAL",
              "LALIT KUMAR",
              "MAHESH SINGH",
              "MANAN JAIN",
              "SAKSHI SHEKHAWAT",
              "VINAYAK VYAS",
              "YOGESH KUMAR VERMA"
            ]}
          ]
        },
        {
          year: "4th Year",
          students: [
            { name: "Section A", count: 68, studentList: [
              "HARDIKA MAKWANA",
              "SIDHARTH JOSHI",
              "GUNJAN AGRAWAL",
              "NEHA SHARMA",
              "PREETI DEORA",
              "RAHUL BHATI",
              "SHREYANSH SHARMA",
              "VASU AGRAWAL",
              "AADITYA MEHTA",
              "AAYUSH SANGWAN",
              "ABHIJEET SHARMA",
              "ANIKA",
              "ANKIT",
              "ANKIT KUMAR",
              "ANUJ AGRAWAL",
              "ARYAN GURJAR",
              "BHAVESH LAKHUJANI",
              "DARSHIL PUNGALIA",
              "DEEPAK",
              "DEV KUMAR AGARWAL",
              "DHEERAJ PANWAR",
              "DIVYAM SHARMA",
              "DIVYANSHU KAROLIWAL",
              "DIYA GAUR",
              "GAJNESH SHARMA",
              "GARVIT JAIN",
              "GARVIT SOLANKI",
              "GIRISH KUMAR",
              "HARSHA SHARMA",
              "HARSHIT SONI",
              "HIMANSHU DHAKER",
              "ISHITA DHARIWAL",
              "KRISH MEHTA",
              "MANISH KUMAR",
              "MUKAND JIRAWLA",
              "NAKSHATRA KATARIA",
              "NARENDRA GURJAR",
              "NEHA SHARMA",
              "NILESH ANJANA",
              "PREM SAGAR",
              "PRIYANKA",
              "RAGHVENDRA VAISHNAV",
              "RAJVEER SINGH RANAWAT",
              "RAMSWAROOP MEENA",
              "RIPUDAMAN SINGH PALAWAT",
              "SHEFALI CHOUHAN",
              "SIDDHESH KUMAR",
              "SONIYA KUMARI SAINI",
              "TANU MEENA",
              "TARUN CHOUDHARY",
              "UTTAM SHARMA",
              "VEDIKA SHARMA",
              "VISHAL DOODI",
              "VISHNU KUMAR JANGID",
              "VRANDA MANIHAR",
              "YASHVARDHAN SINGH",
              "YUVRAJ SINGH",
              "YUVRAJ SINGH RATHORE",
              "YUVRAJ SINGH SHEKHAWAT",
              "PARTHO ROY",
              "UMARDEEN",
              "CHARUL GIRI",
              "HARDYANSHA SWAMI",
              "PRASHANT JHA",
              "SHIFA GYAS",
              "SHIVAM BAHARWANI",
              "SUMIT SINGH",
              "SUVIDH MATHUR"
            ]}
          ]
        }
      ],
      features: [
        "Machine learning algorithms",
        "Deep learning and neural networks",
        "Big data analytics",
        "Natural language processing",
        "Computer vision"
      ]
    }
  ];

  const mcaPrograms = [
    {
      title: "Master of Computer Applications (MCA)",
      icon: <Computer sx={{ fontSize: 40, color: 'primary.main' }} />, 
      description: "The MCA program is designed to provide students with a solid foundation in computer application development, software engineering, and IT management. The curriculum emphasizes both theoretical knowledge and practical skills required for the IT industry.",
      years: [
        {
          year: "MCA Batch 2023-25",
          students: [
            { name: "Section A", count: 0, studentList: [
              // Add MCA student names here
            ]}
          ]
        }
      ],
      features: [
        "Comprehensive curriculum covering programming, databases, and software engineering",
        "Focus on application development and project work",
        "Industry-oriented training and internships",
        "Modern computing labs and resources",
        "Professional skill development and career guidance"
      ]
    }
  ];

  const mePrograms = [
    {
      title: "M.E. Computer Science",
      icon: <Groups sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: "Advanced program focusing on specialized areas of computer science and research.",
      features: [
        "2-year specialized program",
        "Research-oriented curriculum",
        "Industry collaboration",
        "Advanced electives",
        "Thesis work"
      ]
    }
  ];

  const phdPrograms = [
    {
      title: "Ph.D. Computer Science",
      icon: <Science sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: "Doctoral program emphasizing research and innovation in computer science.",
      features: [
        "Research-focused program",
        "Publication opportunities",
        "International collaborations",
        "Teaching experience",
        "Industry partnerships"
      ]
    }
  ];

  const getProgramsForTab = () => {
    switch(selectedTab) {
      case 0:
        return bePrograms;
      case 1:
        return mePrograms;
      case 2:
        return phdPrograms;
      case 3:
        return mcaPrograms;
      default:
        return bePrograms;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box sx={{ 
        py: { xs: 6, md: 10 },
        background: '#fff',
        color: '#1F2937',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '100%',
          background: 'none',
          opacity: 0,
          zIndex: 0
        }
      }}>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="h3" align="center" gutterBottom sx={{ 
            mb: 8,
            fontWeight: 800,
            fontSize: { xs: '2rem', md: '2.5rem' },
            position: 'relative',
            color: '#1F2937',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -16,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 80,
              height: 4,
              background: '#4B5563',
              borderRadius: 2
            }
          }}>
            Our Students
          </Typography>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mb: 6,
            '& .MuiTabs-root': {
              minHeight: 48,
              background: 'rgba(75,85,99,0.08)',
              borderRadius: 2,
              p: 0.5,
            },
            '& .MuiTab-root': {
              color: '#374151',
              minHeight: 48,
              borderRadius: 1,
              fontWeight: 600,
              '&.Mui-selected': {
                color: '#1F2937',
                background: 'rgba(75,85,99,0.15)',
              },
            },
          }}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="B.E. Students" />
              <Tab label="M.E. Students" />
              <Tab label="Ph.D. Students" />
              <Tab label="MCA Students" />
            </Tabs>
          </Box>

          <Grid container spacing={4}>
            {getProgramsForTab().map((program, index) => (
              <Grid item xs={12} md={selectedTab === 0 ? 4 : 6} key={index}>
                <Card sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                  borderRadius: 4,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                  }
                }}>
                  <CardContent sx={{ p: 4, flexGrow: 1 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      mb: 3,
                      gap: 2
                    }}>
                      {program.icon}
                      <Typography variant="h5" sx={{ 
                        fontWeight: 700,
                        color: '#1F2937'
                      }}>
                        {program.title}
                      </Typography>
                    </Box>
                    <Typography variant="body1" paragraph sx={{ mb: 3, color: '#374151' }}>
                      {program.description}
                    </Typography>

                    {selectedTab === 0 && program.years && (
                      <Box sx={{ mb: 3 }}>
                        {program.years.map((yearData, yearIndex) => (
                          <Accordion 
                            key={yearIndex}
                            sx={{ 
                              mb: 1,
                              background: 'rgba(26,35,126,0.05)',
                              '&:before': { display: 'none' },
                              boxShadow: 'none',
                              borderRadius: '8px !important',
                              overflow: 'hidden'
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              sx={{
                                background: 'rgba(26,35,126,0.1)',
                                '&:hover': {
                                  background: 'rgba(26,35,126,0.15)',
                                }
                              }}
                            >
                              <Typography sx={{ fontWeight: 600, color: '#1F2937' }}>
                                {yearData.year}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {yearData.students.map((section, sectionIndex) => (
                                  <Box key={sectionIndex} sx={{ 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    gap: 1,
                                    p: 1,
                                    borderRadius: 1,
                                    background: 'rgba(26,35,126,0.05)',
                                  }}>
                                    <Box sx={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1
                                    }}>
                                      <Typography variant="body2" color="#374151">
                                        {section.name}
                                      </Typography>
                                      <Typography variant="body2" color="#1F2937" fontWeight={600}>
                                        {section.count} Students
                                      </Typography>
                                    </Box>
                                    {section.studentList && (
                                      <Box sx={{ 
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: 1,
                                        mt: 1
                                      }}>
                                        {section.studentList.map((student, studentIndex) => (
                                          <Typography 
                                            key={studentIndex}
                                            variant="body2"
                                            sx={{
                                              p: 0.5,
                                              borderRadius: 1,
                                              background: 'rgba(75,85,99,0.04)',
                                              color: '#374151',
                                              '&:hover': {
                                                background: 'rgba(75,85,99,0.10)',
                                              }
                                            }}
                                          >
                                            {student}
                                          </Typography>
                                        ))}
                                      </Box>
                                    )}
                                  </Box>
                                ))}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </Box>
                    )}

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      {program.features.map((feature, idx) => (
                        <Box key={idx} sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1,
                          color: '#374151'
                        }}>
                          <Box sx={{ 
                            width: 6, 
                            height: 6, 
                            borderRadius: '50%', 
                            bgcolor: 'primary.main' 
                          }} />
                          <Typography variant="body2" sx={{ color: '#374151' }}>
                            {feature}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Students; 